module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img33.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "ch15"
    }
  }), _vm._v("MAY FLOWER COMPACT, 1620")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("O")]), _vm._v("ne of the icons of democracy is the Mayflower Compact, the Pilgrim’s commitment to justice and equality. It was signed on the "), _c('i', [_vm._v("Mayflower")]), _vm._v(" when it landed on Cape Cod in 1620. The Pilgrims, a tiny radical outgrowth of the English Puritan movement, had first tried to settle in Holland but found few chances there to make a living. They returned to England and then set sail for New England.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The crisis for the Pilgrims in Massachusetts came as non-Pilgrims began to move into the colony. Quakers arrived and started to press for rights of citizenship and worship. To maintain control, the Pilgrims dictated that voters had to own property. As much as one-third of the male population lost the right to vote. Civilian control collapsed and brought on the dissolution of the colony in the 1690s. Democracy had collided with the need to maintain ideological religious control of the colony. "), _c('span', {
    staticClass: "color"
  }, [_vm._v("(10-040, 10-041, 10-042)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img34.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c78d9c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter015.vue
// module id = 120
// module chunks = 0